export default __webpack_public_path__ + "static/media/harsilvalley.45c8a2f5.jpg";